<form [formGroup]="formGroup">
  <div data-test="wdo-registration">
    <div class="flex--column">
      <div
        class="spacing--padding-top spacing--padding-bottom text--bold"
        *ngIf="chickAgeInDays >= 0"
      >
        <span class="dialog__title">
          {{ 'wdo-labels.ageInDays' | translate }} {{ chickAgeInDays }}
        </span>
      </div>

      <mat-form-field class="flex__child--auto" *ngIf="showField('mortality')">
        <mat-label>{{ 'wdo-labels.mortality' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          inputmode="decimal"
          formControlName="mortality"
          placeholder="{{ 'wdo-labels.mortality' | translate }}"
          data-test="wdo-registration__mortality"
        />
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('mortality')">
        <mat-label>{{ 'wdo-labels.selection' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          inputmode="decimal"
          formControlName="selection"
          placeholder="{{ 'wdo-labels.selection' | translate }}"
          data-test="wdo-registration__selection"
        />
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('mortality')">
        <mat-label>{{ 'wdo-labels.selectionSmall' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          inputmode="decimal"
          formControlName="selectionSmall"
          placeholder="{{ 'wdo-labels.selectionSmall' | translate }}"
          data-test="wdo-registration__selection_small"
        />
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('mortality')">
        <mat-label>{{ 'wdo-labels.selectionLegProblems' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          inputmode="decimal"
          formControlName="selectionLegProblems"
          placeholder="{{ 'wdo-labels.selectionLegProblems' | translate }}"
          data-test="wdo-registration__selection_leg_problems"
        />
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('feedIntake')">
        <mat-label>{{ feedIntakePlaceholder }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          formControlName="feedIntakeInKg"
          placeholder="{{ feedIntakePlaceholder }}"
          data-test="wdo-registration__feedIntake"
        />
        <span matTextSuffix class="form-field-suffix">{{ feedIntakeSuffix }}</span>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('waterIntake')">
        <mat-label>{{ waterIntakePlaceholder }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          formControlName="waterIntakeInL"
          placeholder="{{ waterIntakePlaceholder }}"
          data-test="wdo-registration__waterIntake"
        />
        <span matTextSuffix class="form-field-suffix">{{ waterIntakeSuffix }}</span>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('indoorTemperature')">
        <mat-label>{{ 'wdo-labels.indoorTemperature' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          formControlName="indoorTemperatureInCelsius"
          placeholder="{{ 'wdo-labels.indoorTemperature' | translate }}"
          data-test="wdo-registration__indoorTemperature"
        />
        <span matTextSuffix class="form-field-suffix">C</span>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('outdoorTemperature')">
        <mat-label>{{ 'wdo-labels.outdoorTemperature' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          formControlName="outdoorTemperatureInCelsius"
          placeholder="{{ 'wdo-labels.outdoorTemperature' | translate }}"
          data-test="wdo-registration__outdoorTemperature"
        />
        <span matTextSuffix class="form-field-suffix">C</span>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('indoorHumidity')">
        <mat-label>{{ 'wdo-labels.indoorHumidity' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          formControlName="indoorHumidityInPercentages"
          placeholder="{{ 'wdo-labels.indoorHumidity' | translate }}"
          data-test="wdo-registration__indoorHumidity"
        />
        <span matTextSuffix class="form-field-suffix">%</span>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('outdoorHumidity')">
        <mat-label>{{ 'wdo-labels.outdoorHumidity' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          formControlName="outdoorHumidityInPercentages"
          placeholder="{{ 'wdo-labels.outdoorHumidity' | translate }}"
          data-test="wdo-registration__outdoorHumidity"
        />
        <span matTextSuffix class="form-field-suffix">%</span>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('weight')">
        <mat-label>{{ 'wdo-labels.weight' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          formControlName="chickWeightInGrams"
          placeholder="{{ 'wdo-labels.weight' | translate }}"
          data-test="wdo-registration__weight"
        />
        <span matTextSuffix class="form-field-suffix">g</span>
      </mat-form-field>
      <ng-container *ngIf="showField('litterQuality')">
        <mat-form-field
          class="flex__child--auto"
          [ngClass]="{ 'mat-form-field-invalid': formGroup.hasError('litterQualityInvalid') }"
        >
          <mat-label>{{ 'wdo-labels.litterQualities.Loose' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="1"
            formControlName="litterQualityLoosePercentage"
            placeholder="{{ 'wdo-labels.litterQualities.Loose' | translate }}"
            data-test="wdo_registration__litterQualityLoosePercentage"
          />
          <span matTextSuffix class="form-field-suffix">%</span>
        </mat-form-field>
        <mat-form-field
          class="flex__child--auto"
          [ngClass]="{ 'mat-form-field-invalid': formGroup.hasError('litterQualityInvalid') }"
        >
          <mat-label>{{ 'wdo-labels.litterQualities.Caked' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="1"
            formControlName="litterQualityCakedPercentage"
            placeholder="{{ 'wdo-labels.litterQualities.Caked' | translate }}"
            data-test="wdo_registration__litterQualityCakedPercentage"
          />
          <span matTextSuffix class="form-field-suffix">%</span>
        </mat-form-field>
        <mat-form-field
          class="flex__child--auto"
          [ngClass]="{ 'mat-form-field-invalid': formGroup.hasError('litterQualityInvalid') }"
        >
          <mat-label>{{ 'wdo-labels.litterQualities.Wet' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="1"
            formControlName="litterQualityWetPercentage"
            placeholder="{{ 'wdo-labels.litterQualities.Wet' | translate }}"
            data-test="wdo_registration__litterQualityWetPercentage"
          />
          <span matTextSuffix class="form-field-suffix">%</span>
        </mat-form-field>
        <div
          data-test="wdo-registration__litter-quality-validation"
          *ngIf="formGroup.hasError('litterQualityInvalid')"
          class="notification notification-error"
        >
          <mat-icon>error</mat-icon>
          {{ 'wdo-registration.validation-errors.total-must-be-100' | translate }}
        </div>
      </ng-container>
    </div>
  </div>
</form>
